import { buildUrl } from './utils';

const state = {};
const actions = {
  create({ rootState: { token } }, { projectId } = {}) {
    console.log('projectId', projectId);
    const url = buildUrl([{ projects: projectId }, { chat: null }]);
    return this._vm.$http.post(url, { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions
};
